<div class="kgr-tabbar">
  <a class="kgr-tabbar__item" routerLinkActive="active" routerLink="/home">
    <svg kgrIcon="house" class="kgr-tabbar__itemIcon"></svg>
    <div class="kgr-tabbar__itemLabel" i18n>Home</div>
  </a>
  <a class="kgr-tabbar__item" routerLinkActive="active" routerLink="/teams">
    <svg kgrIcon="users" class="kgr-tabbar__itemIcon"></svg>
    <div class="kgr-tabbar__itemLabel" i18n>Teams</div>
  </a>
  <a class="kgr-tabbar__item" routerLinkActive="active" routerLink="/news">
    <svg kgrIcon="calendar" class="kgr-tabbar__itemIcon"></svg>
    <div class="kgr-tabbar__itemLabel" i18n>News</div>
  </a>

  <a *kgrIfModuleEnabled="'Chat'" class="kgr-tabbar__item" routerLinkActive="active" routerLink="/chats">
    <svg kgrIcon="chat" class="kgr-tabbar__itemIcon"></svg>
    <div class="kgr-tabbar__itemLabel" i18n>Chats</div>
  </a>

  <a *kgrIfModuleEnabled="'offering'" class="kgr-tabbar__item" routerLinkActive="active" routerLink="/offerings">
    <svg kgrIcon="local-offer" class="kgr-tabbar__itemIcon"></svg>
    <div class="kgr-tabbar__itemLabel" i18n>Angebot</div>
  </a>
</div>
